<template>
  <EditorAutoComplete
    title="所在城市"
    :value="value"
    :remoteMethodCallback="fetchCitiesRemoteMethod"
    @clickPickerItem="clickSinglePickerValue"
  />
</template>
<script>
import api from '@/api';
import EditorAutoComplete from '../EditorAutoComplete/EditorAutoComplete.vue';
export default {
  name: 'EditorCityPicker',
  components: {
    EditorAutoComplete,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  methods: {
    async fetchCitiesRemoteMethod(query) {
      try {
        return await api.cvsEditor.cityAutoCompletions({
          keyword: query,
        });
      } catch (error) {
        console.log(error);
      }
    },
    clickSinglePickerValue(data) {
      this.$emit('confirm', data);
    },
  },
};
</script>
<style lang="scss" scoped></style>
